import logging from '@wr/logging';
import {fetchProvider} from '../../utils/fetchProvider';
import eventIds from '../../event-ids';
import config from '../../config';

const logger = logging.createLogger(config.app.name, config.logger.logServerUrl);

export async function confirmPaymentMethod(sessionId, languageCode, csrfToken) {
    try {
        /* eslint-disable max-len */
        const confirmationResponse = await fetchProvider(`/${languageCode}/payment-providers/mbt/confirmation/${sessionId}`, {
            method: 'PUT',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                'csrf-token': csrfToken
            }
        });
        logger.info('Retrieved Manual bank transfer confirmation');
        return await confirmationResponse;
    } catch (error) {
        logger.error(`Error retrieving Manual bank transfer confirmation: ${error.message}`, {
            error,
            eventId: eventIds['Error retrieving Manual bank transfer confirmation']
        });
        throw error;
    }
}
